import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, KeyRound, Save } from "lucide-react";
import { api, formatApiError } from "@/lib/apiClient";

export default function AdminCashSettings() {
  const [target, setTarget] = useState("staff");
  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    if (!loginId && !password) return toast.error("Enter a new Login ID or password");
    if (!window.confirm(`Update ${target.toUpperCase()} credentials? This takes effect on the next login.`)) return;
    setBusy(true);
    try {
      await api.put("/admin/cash/credentials", {
        target,
        login_id: loginId || undefined,
        password: password || undefined,
      });
      toast.success("Credentials updated");
      setLoginId(""); setPassword("");
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setBusy(false); }
  };

  return (
    <div data-testid="admin-cash-settings" className="max-w-xl">
      <header className="mb-6">
        <Link to="/admin/cash" className="text-xs text-brand-charcoal/60 hover:text-brand-charcoal inline-flex items-center gap-1"><ArrowLeft size={12} /> Back to Today</Link>
        <h1 className="editorial-h1 text-4xl mt-2">Security</h1>
        <p className="text-sm text-brand-charcoal/60 mt-1">Change the Staff or Master credentials. Passwords are hashed on the server.</p>
      </header>

      <div className="rounded-2xl bg-white border border-brand-line p-5">
        <div className="text-[11px] uppercase tracking-widest text-brand-charcoal/55 mb-3 inline-flex items-center gap-1"><KeyRound size={11} /> Change credentials</div>
        <div className="space-y-3">
          <div>
            <label className="text-[10px] uppercase tracking-widest text-brand-charcoal/55">Account</label>
            <div className="flex gap-2 mt-1">
              <button onClick={() => setTarget("staff")} className={`btn-pill text-xs ${target === "staff" ? "btn-dark" : "btn-ghost"}`} data-testid="cred-target-staff">Staff</button>
              <button onClick={() => setTarget("master")} className={`btn-pill text-xs ${target === "master" ? "btn-dark" : "btn-ghost"}`} data-testid="cred-target-master">Master</button>
            </div>
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-widest text-brand-charcoal/55">New Login ID (optional)</label>
            <input value={loginId} onChange={(e) => setLoginId(e.target.value.toUpperCase())} placeholder="Leave blank to keep unchanged" className="pp-input" data-testid="cred-login-id" />
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-widest text-brand-charcoal/55">New Password (optional)</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Min 4 characters" className="pp-input" data-testid="cred-password" />
          </div>
          <button onClick={save} disabled={busy} className="btn-pill btn-dark text-xs disabled:opacity-60" data-testid="cred-save"><Save size={11} /> Save</button>
        </div>
      </div>

      <div className="mt-4 rounded-2xl bg-amber-50 border border-amber-200 p-4 text-xs text-amber-800">
        <strong>Default credentials:</strong> Staff <code>POPPANDA / POPPANDA</code>, Master <code>POPPANDA2026 / POPPANDA2026</code>. Change them before real-world use.
      </div>
    </div>
  );
}
